export default {"src":"/_next/static/media/powr.f201511a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};